import { render } from "./TheSocialIcons.vue?vue&type=template&id=58f7f062&scoped=true"
import script from "./TheSocialIcons.vue?vue&type=script&lang=js"
export * from "./TheSocialIcons.vue?vue&type=script&lang=js"

import "./TheSocialIcons.vue?vue&type=style&index=0&id=58f7f062&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f7f062"]])

export default __exports__